import {Segment} from 'semantic-ui-react';
import MainLayout from '../layouts/main';
import PaymentVerify from './payment-verify';

function TransactionVerifyPage() {
  return (
    <MainLayout consultPackageRequired={false} packageRequired={false}>
      <Segment textAlign='center' size='big'>
        <PaymentVerify/>
      </Segment>
    </MainLayout>
  );
}

export default TransactionVerifyPage;
